import type React from 'react';

import { IconButton, Stack } from '@mui/material';

import { Iconify } from '../../Iconify';

interface StepButtonsProps {
  handleManualStep: (direction: 'down' | 'up') => void;
  value: number | string;
  disabled?: boolean;
  max?: number;
  min?: number;
}

const StepButtons: React.FC<StepButtonsProps> = ({
  disabled,
  handleManualStep,
  max,
  min,
  value,
}) => {
  return (
    <Stack
      className="animate-in fade-in duration-200"
      justifyContent="center"
      alignItems="center"
      direction="column"
    >
      <IconButton
        disabled={disabled || (max !== undefined && Number(value) >= max)}
        onMouseDown={(e: React.MouseEvent) => e.preventDefault()}
        onClick={() => handleManualStep('up')}
        className="p-0 m-0"
        size="small"
      >
        <Iconify icon="mdi:chevron-up" size={'small'} />
      </IconButton>

      <IconButton
        disabled={disabled || (min !== undefined && Number(value) <= min)}
        onMouseDown={(e: React.MouseEvent) => e.preventDefault()}
        onClick={() => handleManualStep('down')}
        className="p-0 m-0"
        size="small"
      >
        <Iconify icon="mdi:chevron-down" size={'small'} />
      </IconButton>
    </Stack>
  );
};

export default StepButtons;
